export const translations = {
  main: {
    errorBoundary: {
      errorOccurred: 'Error occurred while processing payments.',
    },
  },
  notfound: {
    notFound: {
      code404: '404 Not Found',
    },
  },
  currency: {
    AED: 'AED',
    SAR: 'SAR',
  },
  price: '{amount, currency}',
  checkout: {
    summary: {
      paymentSummary: 'Payment Summary',
      subtotal: 'Subtotal',
      discount: 'Discount',
      discountPrice: '- <price/>',
      tips: 'Tips',
      serviceFee: 'Service Fee',
      totalAmount: 'Total Amount',
    },
    splitBillInfo: {
      splitByVar: 'Bill has been split by {numberOfSplits} people equally',
      splitByItems: 'Bill has been split by items.',
    },
    splitEqualMode: {
      peopleOnTable: 'How many are on the table?',
      payingFor: "How many you're paying for?",
      leftToPay: 'Left to pay',
      yourShare: 'Your share',
      removeSplit: 'Remove split',
      confirm: 'Confirm',
    },
    splitByItems: {
      title: 'Pay for your items',
      leftToPay: 'Left to pay',
      yourShare: 'Your share',
      removeSplit: 'Remove split',
      confirm: 'Confirm',
      noItems: 'No items to split',
      back: 'Back',
      conflictAlert: 'Some items were just paid by someone else — please review your selection',
    },
    paymentsErrorBoundary: {
      errorOccurred: 'Error occurred while processing payments.',
    },
    tipChip: {
      custom: 'Custom',
      mostCommon: 'Most common',
      noThanks: 'No, Thanks',
      percentage: '{percentage}%',
    },
    withAmountDebounce: {
      loading: 'Loading...',
    },
    tips: {
      tipServer: 'Tip your server',
      tipGoesToServer: '100% of your tip will go to your server',
    },
    splitSummary: {
      splitSummary: 'Payment Split Summary',
      totalBill: 'Total bill',
      yourShare: 'Your share',
    },
    splitBill: {
      splitEqually: 'Split equally',
      splitBill: 'Split bill',
      editSplit: 'Edit split',
      payForItems: 'Pay for your items',
      payForItemsUnavailable: 'Not available on orders that contain Tobacco items',
      select: 'Select',
      back: 'Back',
    },
    checkoutController: {
      payments: 'Payments',
      splitExpired: 'Your split payments has expired',
      orderNumberVar: 'Order Number: {orderNumber}',
      remainingAmountVar: 'Remaining Amount: {remainingAmount}',
      contactRestaurant: 'Please contact the restaurant to pay for your bill',
    },
    serviceFeeInfo: {
      serviceFee: 'Service Fee',
      feeDescription:
        'The fee covers the convenience of using QR code payments, a secure, fast, and seamless way to pay your bill, with the added benefit of splitting it with others.',
      gotIt: 'Got it',
    },
    customTip: {
      customTip: 'Custom tip',
      aedLabel: 'AED',
    },
    infoAlert: {
      billUpdated: 'Your bill was updated, please review and proceed again',
      splitCreationFailed: "We couldn't set up your split. Please try again.",
    },
    summaryRow: {
      infoIcon: 'Info icon',
    },
    increaseDecreaseNumber: {
      minus: 'Minus',
      plus: 'Plus',
      decrease: 'Decrease',
      increase: 'Increase',
    },
    bill: {
      yourOrder: 'Your order',
      collapseIcon: 'Collapse icon',
      quantity: '{quantity}x',
      modifierQuantity: ' (x{quantity})',
    },
  },
  menu: {
    addToCart: 'Add to cart',
    orderPromptModal: {
      title: 'Want to order from your table?',
      description:
        'Download our app today, earn up to {cashbackPercentageValue}% cashback, access exclusive deals, and order right from your seat.',
      downloadApp: 'Download app',
    },
    itemCardCashbackPill: {
      earnCashback: {
        AED: 'Earn AED',
        SAR: 'Earn SAR',
      },
      kitopi: 'Kitopi',
    },
    brandPresentation: {
      table: 'Table',
      menu: 'Menu',
    },
    entry: {
      tableVar: 'Table {tableNumber}',
      payNow: 'Pay now',
      viewMenu: 'View menu',
      signUpBonus: {
        firstLine: 'SIGN UP',
        secondLine: 'BONUS',
      },
      bonusTooltipWithBonus:
        '{bonusValue} {currency} today & <br/> up to {cashbackPercentageValue}% cashback <br/> on every order',
      bonusTooltipWithoutBonus: 'Up to {cashbackPercentageValue}% cashback <br/> on every order',
      promoWithMinimumSpend: '{minimumSpend} {currency} Minimum Spend',
      termsConditionsApply: 'Terms & Conditions apply',
    },
    itemDetailsSkeleton: {
      close: 'Close',
    },
    itemDetails: {
      close: 'Close',
      required: 'Required',
      optional: 'Optional • Choose up to {maximumSelectedElements}',
      allergens: 'Allergens',
    },
  },
  paymentConfirmation: {
    successTitle: {
      paymentSuccessful: 'Payment successful',
      youveEarned: "YOU'VE EARNED",
      signupBonus: 'SIGN UP BONUS',
      useAcross: 'Use across +200 restaurants for Dine-in & Delivery',
      kitopi: 'Kitopi',
      getUpToXCashback: {
        firstLine: 'Get up to {cashbackPercentageValue}%',
        secondLine: 'cashback',
      },
    },
    streak: {
      startYourStreak: 'Start your streak!',
    },
    countDown: {
      timeToClaimCashback: 'Time remaining to claim your cashback',
    },
    paymentConfirmation: {
      downloadApp: 'Download Kitopi app to claim',
      downloadKitopiApp: 'Download Kitopi app',
      troubleDownloading: 'Trouble downloading? Click the icon to copy the link.',
      copied: 'Copied!',
      failedToCopy: 'Failed to copy',
      askForReceipt: 'Ask waiter for receipt',
      cashbackWithKitopi: 'Get cashback with Kitopi app',
      cashbackWhenPay: 'Get cashback when you pay in the app',
      copy: 'Copy',
      copyLink: 'Copy link',
      hopeYouEnjoyed: {
        firstLine: 'Hope you',
        secondLine: 'enjoyed',
        thirdLine: 'your meal',
      },
    },
  },
  paymentFailure: {
    paymentFailure: {
      paymentFailed: 'Payment Failed',
      sorryUnsuccessful: 'Sorry, your payment was unsuccessful',
      billUnpaid: 'billUnpaid',
    },
  },
  cashbackBanner: {
    cashbackBannerController: {
      getCashbackInApp: 'Get cashback when you pay in the app',
      getCashbackWithKitopi: 'Get cashback with the Kitopi app',
    },
    cashbackIcon: 'Cashback icon',
    closeIcon: 'Close icon',
  },
  rewards: {
    kitopiCoinSmall: 'Kitopi Coin Small',
    earnWithSignupBonus: "You'll earn {currency} <amount/> sign up bonus",
    earnWithOrder: "You'll earn {currency} <amount/> with this order",
    excludesTobacco: 'Excludes tobacco products',
  },
  sharedButton: {
    logo: 'logo',
  },
  bottomSheet: {
    close: 'Close',
  },
  brandHeader: {
    back: 'Back',
    seeLess: 'See less',
    seeMore: 'See more',
    star: 'Star',
    goBack: 'Go back',
    search: 'Search',
  },
  languageSwitcher: {
    language: 'Language',
    switchTo: 'Switch to {language}',
  },
  viewSwitcher: {
    gridView: 'Grid view',
    listView: 'List view',
    switchToListView: 'Switch to list view',
    switchToGridView: 'Switch to grid view',
  },
  menuCategories: {
    jumpTo: 'Jump to',
  },
  infoAlert: {
    infoIcon: 'Info icon',
  },
  noBill: {
    restaurant: 'restaurant',
    looksLikeNoOrder: "Looks like you haven't ordered yet",
    billWillAppear: 'Your bill will appear when you order',
    downloadAppCashback:
      'Download the app and get up to {cashbackPercentageValue}% cashback after your meal!',
    downloadKitopiApp: 'Download Kitopi App',
  },
  terms: {
    fullMessage:
      'By using {domain} you accept our <termsLink>Terms and Conditions</termsLink> and <privacyLink>Privacy Policy</privacyLink>.',
  },
  successSummary: {
    loading: 'Loading ...',
    partiallyPaid: 'Partially paid',
    fullyPaid: 'Fully paid',
    tableDineIn: 'Table Dine in {tableNumber}',
    counterNumber: 'Counter number {counterNumber}',
    tipAmount: 'Tip amount',
    serviceFee: 'Service fee',
    youPaid: 'You paid',
  },
};
